import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=8e7e8e42"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports